import React, { useEffect } from 'react';
import HelpLayout from '../../../components/help/HelpLayout';

const CourseManagementHelp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const breadcrumbs = [
    { name: 'Admin Guide', href: '/help/admin/dashboard' },
    { name: 'Course Management' }
  ];

  return (
    <HelpLayout title="Course Management" breadcrumbs={breadcrumbs}>
      <div className="help-content">
        <div className="card">
          <div className="card-body">
            <h2 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: 'var(--primary-black)',
              marginBottom: '16px'
            }}>
              Course Management Guide
            </h2>
            <p style={{
              fontSize: '16px',
              color: 'var(--text-gray)',
              lineHeight: 1.6
            }}>
              Create, edit, and manage training programs including capacity management and course updates.
            </p>

            {/* Access Requirements */}
            <div style={{
              padding: '20px',
              backgroundColor: '#fee2e2',
              borderRadius: '8px',
              marginTop: '24px',
              border: '1px solid #ef4444'
            }}>
              <h3 style={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#dc2626',
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                🔒 Administrator Access Required
              </h3>
              <p style={{ color: '#dc2626', margin: 0, lineHeight: 1.6 }}>
                Course management functions require administrator or staff privileges. Contact your system administrator
                if you need access to these features.
              </p>
            </div>

            {/* Django Admin Access */}
            <div style={{ marginTop: '32px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px'
              }}>
                🛠️ Course Management via Django Admin
              </h3>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Accessing Course Management
                </h4>
                <p style={{ color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: '12px' }}>
                  Course management is primarily handled through the Django Admin interface:
                </p>
                <ol style={{
                  color: 'var(--text-gray)',
                  lineHeight: 1.6,
                  paddingLeft: '20px',
                  marginBottom: '16px'
                }}>
                  <li>Navigate to <strong>/admin/</strong> from the main application</li>
                  <li>Log in with your administrator credentials</li>
                  <li>Access <strong>Courses → Courses</strong> for course management</li>
                  <li>Use <strong>Courses → Course intakes</strong> for intake management</li>
                </ol>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Course Creation Process
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div style={{
                    padding: '16px',
                    backgroundColor: 'var(--background-gray)',
                    borderRadius: '8px',
                    borderLeft: '4px solid var(--primary-yellow)'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: 'var(--primary-black)',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{
                        backgroundColor: 'var(--primary-yellow)',
                        color: 'var(--primary-black)',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                        fontWeight: 'bold'
                      }}>1</span>
                      Basic Course Information
                    </h5>
                    <ul style={{ fontSize: '14px', color: 'var(--text-gray)', margin: 0, paddingLeft: '20px' }}>
                      <li>Programme name and description</li>
                      <li>Trade specialisation and category</li>
                      <li>NQF level and credit value</li>
                      <li>Duration in months</li>
                    </ul>
                  </div>

                  <div style={{
                    padding: '16px',
                    backgroundColor: 'var(--background-gray)',
                    borderRadius: '8px',
                    borderLeft: '4px solid var(--primary-yellow)'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: 'var(--primary-black)',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{
                        backgroundColor: 'var(--primary-yellow)',
                        color: 'var(--primary-black)',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                        fontWeight: 'bold'
                      }}>2</span>
                      Requirements and Prerequisites
                    </h5>
                    <ul style={{ fontSize: '14px', color: 'var(--text-gray)', margin: 0, paddingLeft: '20px' }}>
                      <li>Entry requirements and minimum qualifications</li>
                      <li>Age requirements and physical requirements</li>
                      <li>Prerequisites and recommended background</li>
                      <li>Language requirements</li>
                    </ul>
                  </div>

                  <div style={{
                    padding: '16px',
                    backgroundColor: 'var(--background-gray)',
                    borderRadius: '8px',
                    borderLeft: '4px solid var(--primary-yellow)'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: 'var(--primary-black)',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{
                        backgroundColor: 'var(--primary-yellow)',
                        color: 'var(--primary-black)',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                        fontWeight: 'bold'
                      }}>3</span>
                      Location and Logistics
                    </h5>
                    <ul style={{ fontSize: '14px', color: 'var(--text-gray)', margin: 0, paddingLeft: '20px' }}>
                      <li>Campus assignment and training venue</li>
                      <li>Quality partner and accreditation details</li>
                      <li>Capacity limits and class sizes</li>
                      <li>Stipend amounts (if applicable)</li>
                    </ul>
                  </div>

                  <div style={{
                    padding: '16px',
                    backgroundColor: 'var(--background-gray)',
                    borderRadius: '8px',
                    borderLeft: '4px solid var(--primary-yellow)'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: 'var(--primary-black)',
                      marginBottom: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      <span style={{
                        backgroundColor: 'var(--primary-yellow)',
                        color: 'var(--primary-black)',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '10px',
                        fontWeight: 'bold'
                      }}>4</span>
                      SAQA Integration
                    </h5>
                    <ul style={{ fontSize: '14px', color: 'var(--text-gray)', margin: 0, paddingLeft: '20px' }}>
                      <li>SAQA ID for qualification lookup</li>
                      <li>Learning outcomes and assessment criteria</li>
                      <li>Career opportunities and pathways</li>
                      <li>Articulation possibilities</li>
                    </ul>
                  </div>
                </div>
              </div>
            {/* Capacity Management */}
            <div style={{ marginTop: '32px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px'
              }}>
                👥 Capacity Management
              </h3>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Setting Course Capacity
                </h4>
                <p style={{ color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: '12px' }}>
                  Proper capacity management ensures optimal class sizes and resource allocation:
                </p>
                <ul style={{
                  color: 'var(--text-gray)',
                  lineHeight: 1.6,
                  paddingLeft: '20px',
                  marginBottom: '16px'
                }}>
                  <li><strong>Maximum Capacity:</strong> Set based on classroom size and equipment availability</li>
                  <li><strong>Minimum Capacity:</strong> Ensure viable class sizes for effective training</li>
                  <li><strong>Current Enrollment:</strong> Track real-time registration numbers</li>
                  <li><strong>Waitlist Management:</strong> Handle overflow applications appropriately</li>
                </ul>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Monitoring Enrollment
                </h4>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                  gap: '16px',
                  marginBottom: '16px'
                }}>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#dcfce7',
                    borderRadius: '6px',
                    border: '1px solid #16a34a'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#16a34a',
                      marginBottom: '8px'
                    }}>
                      📊 Real-time Updates
                    </h5>
                    <p style={{ fontSize: '14px', color: '#16a34a', margin: 0 }}>
                      Capacity automatically updates when students register or withdraw
                    </p>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#fef3c7',
                    borderRadius: '6px',
                    border: '1px solid #f59e0b'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#d97706',
                      marginBottom: '8px'
                    }}>
                      ⚠️ Capacity Alerts
                    </h5>
                    <p style={{ fontSize: '14px', color: '#d97706', margin: 0 }}>
                      Automatic notifications when courses approach capacity limits
                    </p>
                  </div>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#e0f2fe',
                    borderRadius: '6px',
                    border: '1px solid #0284c7'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#0284c7',
                      marginBottom: '8px'
                    }}>
                    📈 Enrollment Reports
                    </h5>
                    <p style={{ fontSize: '14px', color: '#0284c7', margin: 0 }}>
                      Track enrollment trends and capacity utilization over time
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Course Intake Management */}
            <div style={{ marginTop: '32px' }}>
              <h3 style={{
                fontSize: '20px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px'
              }}>
                📅 Course Intake Management
              </h3>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Creating Course Intakes
                </h4>
                <p style={{ color: 'var(--text-gray)', lineHeight: 1.6, marginBottom: '12px' }}>
                  Course intakes define specific enrollment periods and training schedules:
                </p>
                <ul style={{
                  color: 'var(--text-gray)',
                  lineHeight: 1.6,
                  paddingLeft: '20px',
                  marginBottom: '16px'
                }}>
                  <li><strong>Intake Name:</strong> Descriptive name (e.g., "January 2024 Intake")</li>
                  <li><strong>Start and End Dates:</strong> Training period duration</li>
                  <li><strong>Application Deadlines:</strong> Registration cutoff dates</li>
                  <li><strong>Capacity Limits:</strong> Maximum students for this intake</li>
                  <li><strong>Status Management:</strong> Control intake availability</li>
                </ul>
              </div>

              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  fontSize: '16px',
                  fontWeight: '600',
                  color: 'var(--primary-black)',
                  marginBottom: '12px'
                }}>
                  Intake Status Management
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <div style={{
                    padding: '16px',
                    backgroundColor: '#e0f2fe',
                    borderRadius: '6px',
                    borderLeft: '4px solid #0284c7'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#0284c7',
                      marginBottom: '4px'
                    }}>
                      📋 Upcoming
                    </h5>
                    <p style={{ fontSize: '14px', color: '#0284c7', margin: 0 }}>
                      Intake planned but not yet open for applications
                    </p>
                  </div>

                  <div style={{
                    padding: '16px',
                    backgroundColor: '#dcfce7',
                    borderRadius: '6px',
                    borderLeft: '4px solid #16a34a'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#16a34a',
                      marginBottom: '4px'
                    }}>
                      ✅ Open for Registration
                    </h5>
                    <p style={{ fontSize: '14px', color: '#16a34a', margin: 0 }}>
                      Currently accepting applications from students
                    </p>
                  </div>

                  <div style={{
                    padding: '16px',
                    backgroundColor: '#fee2e2',
                    borderRadius: '6px',
                    borderLeft: '4px solid #ef4444'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#dc2626',
                      marginBottom: '4px'
                    }}>
                      🚫 Registration Closed
                    </h5>
                    <p style={{ fontSize: '14px', color: '#dc2626', margin: 0 }}>
                      No longer accepting new applications
                    </p>
                  </div>

                  <div style={{
                    padding: '16px',
                    backgroundColor: '#fef3c7',
                    borderRadius: '6px',
                    borderLeft: '4px solid #f59e0b'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#d97706',
                      marginBottom: '4px'
                    }}>
                      🎓 In Progress
                    </h5>
                    <p style={{ fontSize: '14px', color: '#d97706', margin: 0 }}>
                      Training currently underway
                    </p>
                  </div>

                  <div style={{
                    padding: '16px',
                    backgroundColor: '#f3f4f6',
                    borderRadius: '6px',
                    borderLeft: '4px solid #6b7280'
                  }}>
                    <h5 style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#6b7280',
                      marginBottom: '4px'
                    }}>
                      ✅ Completed
                    </h5>
                    <p style={{ fontSize: '14px', color: '#6b7280', margin: 0 }}>
                      Training finished, certificates issued
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Best Practices */}
            <div style={{
              padding: '20px',
              backgroundColor: 'var(--background-gray)',
              borderRadius: '8px',
              marginTop: '32px'
            }}>
              <h3 style={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: 'var(--primary-black)',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                💡 Course Management Best Practices
              </h3>
              <ul style={{
                color: 'var(--text-gray)',
                lineHeight: 1.6,
                paddingLeft: '20px',
                margin: 0
              }}>
                <li><strong>Regular capacity monitoring:</strong> Check enrollment numbers frequently</li>
                <li><strong>Clear course descriptions:</strong> Provide detailed, accurate information</li>
                <li><strong>Timely intake creation:</strong> Plan intakes well in advance</li>
                <li><strong>Proper SAQA integration:</strong> Ensure all qualifications are properly linked</li>
                <li><strong>Accurate requirements:</strong> Keep entry requirements up to date</li>
                <li><strong>Campus coordination:</strong> Verify venue availability before scheduling</li>
                <li><strong>Quality partner liaison:</strong> Maintain communication with training providers</li>
                <li><strong>Documentation maintenance:</strong> Keep all course materials current</li>
              </ul>
            </div>

            </div>
          </div>
        </div>
      </div>
    </HelpLayout>
  );
};

export default CourseManagementHelp;
